<template>
  <div class="calc-custo-cnpj">
    <h2>Calculadora Custo para tirar CNPJ</h2>
    <p>Responda as perguntas abaixo e confira quais são os principais custos.</p>

    <div
    id="loading"
    :class="{'loading--show': loading}"
    class="loading"
    >
      <span class="spinner" />
      <h3>Aguarde</h3>
      <p>Calculando...</p>
    </div>

    <div class="form" v-show="!loading">
      <label for="nome">
        <strong>Qual é seu nome?</strong>
        <InputName
          @validName="validacoes.nome = $event"
          @NameField="nome = $event"
        />
      </label>

      <label>
        <strong>Qual atividade você exerce ou exercerá?</strong>

        <Dropdown
          :items="atividades"
          :external-select="selectAtividade"
          :selected-item="atividade"
          placeholder="Selecione uma das opções"
        />
       </label>

      <label for="cidade" class="form__label-cidade">
        <strong>Em qual cidade você pretende abrir sua empresa?</strong>

        <InputCidade
          :valid="(validacoes.cidade)"
          :error="(!validacoes.cidade && cidade.length > 3)"
          :select-cidade="selectCidade"
          :has-description="false"
          :normalize-search="true"
          @validInput="validacoes.cidade = $event"
        />
      </label>

      <label for="faturamento">
        <div class="content-tooltip">
          <strong>
            Quanto você prevê que sua empresa faturará mensalmente?
          </strong>
          <TooltipText
            :text="'O percentual de imposto poderá aumentar de acordo com o valor do seu faturamento.'"
            :class-name="'marginl-40'"
            class="tooltip"
            style="margin-bottom:-2px"
          />
        </div>

        <InputFaturamento
          v-model.lazy="faturamentoMensal"
          :valid="validacoes.faturamentoMensal"
          :error="(toFloatNumber(faturamentoMensal) > 0 && !validacoes.faturamentoMensal)"
          @input="validacoes.faturamentoMensal = validators.recebeMensalmente.valid(faturamentoMensal, 500)"
        />
       </label>

      <label for="email">
        <strong>Qual é o seu e-mail?</strong>

        <InputEmail
          v-model.lazy="email"
          @input="validacoes.email = validators.email.valid(email)"
          :valid="validacoes.email"
        />
      </label>

      <label for="telefone">
        <strong>Qual é seu número de WhatsApp?</strong>

        <InputPhone
          v-model="telefone"
          :valid="validationRules.cellphone.valid(telefone)"
          :error="validationRules.cellphone.error(telefone)"
          @input="validacoes.telefone = validationRules.cellphone.valid(telefone)"
          :string-mask="validationRules.cellphone.mask"
        />
      </label>
      <p class="termo-aceite">Ao clicar em Ver resultado, você está ciente e concorda com a nossa <a href="https://www.contabilizei.com.br/documentos/politica-de-privacidade.pdf" rel=noopener target="_blank">Política de Privacidade</a>, <a href="https://www.contabilizei.com.br/politica-cookies/" rel=noopener target="_blank">Política de Cookies</a> e <a href="https://www.contabilizei.com.br/termos-de-uso/201802_TERMO_DE_USO_Site.pdf" rel=noopener target="_blank">nossos Termos de Uso.</a></p>
      <ButtomPrimary
        :disabled="disableContinue"
        :texto="'Ver resultado'"
        class="actions__continue"
        :deepClass="'blue-light'"
        @click="onClickContinue"
      />

    </div>
  </div>
</template>
<script>

import { VMoney } from 'v-money';
import axios from 'axios';
import InputName from '@/components/Inputs/InputName.vue'
import InputEmail from '@/components/Inputs/InputEmail.vue'
import InputPhone from '@/components/Inputs/InputPhone.vue'
import InputCidade from '@/components/Inputs/InputCidade.vue'
import InputFaturamento from '@/components/Inputs/InputFaturamento.vue'
import ButtomPrimary from '@/components/ButtomPrimary'
import TooltipText from '@/components/TooltipText'
import Dropdown from '@/components/DropDown'
import atividadesJson from '@/assets/json/atividades.json'
import ValidationRules from '@/assets/js/util/validationRules'
import ValidatorSalary from '@/assets/js/util/validationRules/Salary';
import ValidatorEmail from '@/assets/js/util/validationRules/Email';
import { getLocationByAzion } from '@/assets/js/util/verificaCity';
import { slug, removeAccents } from '@/assets/js/util/slugUtil';

import cidadesAtendidas from '@/assets/json/ListaCompletaCidadesAtendidas.json'
import calculatorCustoCnpjService from '@/assets/js/services/CalculatorCustoCnpjService.js';
import cidadesBrasileiras from '@/assets/json/cidadesBrasileiras.json';

export default {
  components: {
    Dropdown,
    InputName,
    InputEmail,
    InputPhone,
    InputCidade,
    InputFaturamento,
    ButtomPrimary,
    TooltipText
  },
  directives: {
    money: VMoney
  },
  data() {
    return {
      atividade: '',
      telefone: '',
      cidade: '',
      email: '',
      nome: '',
      faturamentoMensal: '',
      defaultValueCity: null,
      validationRules: new ValidationRules(),
      loading: false,
      locationValue: '',
      cidadeAtendida: '',
      validacoes: {
        nome: false,
        email: false,
        atividade: false,
        telefone: false,
        validate: false,
        faturamentoMensal: false,
        cidade: false,
        readyCidade: false,
      },
      atividades: atividadesJson,
      validators: {
        recebeMensalmente: new ValidatorSalary(),
        email: new ValidatorEmail(),
      },
    }
  },
  props: {
    pageExperts: {
      type: Boolean,
      default: false
    },
  },
  methods: {
    isProd() {
      return ['www.contabilizei.com.br', 'blog.contabilizei.com.br'].includes(window.location.hostname);
    },
    selectAtividade(key) {
      this.atividade = key
      this.validacoes.atividade = key !== ''
    },
    validarCidade(cidade) {
      this.validacoes.cidade = (cidade.trim().length >= 3)
      this.validacoes.readyCidade = true;
    },
    normalizeText(text) {
      return (text || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
    },
    isCidadeAtendida(cidade) {
      return cidadesAtendidas.some((cidadeAtend) => {
        if (this.pageExperts) {
          const cityUf = `${this.normalizeText(cidadeAtend.cidade)} - ${this.normalizeText(cidadeAtend.uf)}`;
          return cityUf === this.normalizeText(cidade);
        }

        return this.normalizeText(cidadeAtend.cidade) === this.normalizeText(cidade);
      });
    },
    formatCidade(cidade) {
      return cidade.normalize('NFD').replace(/ /g, '').replace(/[\u0300-\u036f]/g, '').toLowerCase()
    },
    selectCidade(cidade) {
      const cidadeEscolhida = cidadesAtendidas.some((cidadeAtend) => {
        return this.formatCidade(cidadeAtend.cidade) === this.formatCidade(cidade)
      })

      this.validacoes.cidade = cidadeEscolhida
      this.cidade = cidade
    },
    populateFormFields() {
      if (!this.formFields) {
        return
      }

      const validations = {

        cidade: (cidade) => {
          this.selectCidade(cidade);
          this.validarCidade(cidade);
        },
        telefone: this.validartelefone,
      }

      const fieldsName = Object.keys(this.formFields)

      fieldsName.forEach((fieldName) => {
        const value = this.formFields[fieldName]

        if (value) {
          this[fieldName] = value

          const validation = validations[fieldName]

          if (validation) {
            validation(value)
          }
        }
      })
    },
    toFloatNumber(value) {
      if (!value) {
        return null;
      }
      return this.validators.recebeMensalmente.getFloatNumber(value);
    },
    isValidStepFinal() {
      return (
        this.validacoes.nome
        && this.validacoes.email
        && this.validacoes.telefone
        && this.validacoes.atividade
        && this.validacoes.faturamentoMensal
        && this.validacoes.cidade
      )
    },
    getCityNormalized(cityName) {
      const cities = cidadesBrasileiras;

      const cityData = cities.find((city) => {
        return this.formatCidade(city.nome) === this.formatCidade(cityName);
      });

      return cityData.nome
    },
    criarContatoHubspot(contact) {
      if(!contact && !contact.email) {
        return false
      }

      return this.sendByFormAPI(contact)
    },
    convertMotivoRecusa(param) {
      if (param.motivos_recusa === ' ') {
        param.motivos_recusa = 'Nenhum'
      }
      return param
    },
    sendByFormAPI (param) {
      const payload = this.convertMotivoRecusa({ ...param });

      const context = {
        hutk: Cookies.get('hubspotutk'),
        pageUri: window.location.href,
        pageName: document.title
      }

      payload.context = context;

      return axios.post(`${this.VUE_APP_API_FORMS}`, payload)
        .then((result) => ({
          hash: result.data.hash
        }))
        .catch((error) => {
          Promise.reject('Error fetching api forms', error)
        });
    },
    async triggerHubspot() {
      const salario = this.toFloatNumber(this.faturamentoMensal);
      const validarFaturamento = salario >= 4000

      const validarColdCall = validarFaturamento && this.cidadeAtendida;
      const payload = {
        opt_in: true,
        firstname: this.nome,
        email: this.email,
        segmento_profissao_site: this.atividade,
        eu_recebo_mensalmente__faixa_: this.faturamentoMensal,
        cidade_da_empresa: this.getCityNormalized(this.cidade),
        cidade_atendida: this.cidadeAtendida,
        city: this.locationValue,
        phone: this.telefone,
        origem: 'Calculadora Custo CNPJ Blog',
        clientid: window.Cookies.get('_gaclientid'),
        lifecyclestage:'lead',

        cidade_atendida_cold_call_materiais: validarColdCall ? 'sim' : 'Não',
      }

      this.criarContatoHubspot(payload).then(contato => {
        if (contato.hash) {
          dataLayer.push({
            event: 'identificacao',
            email: this.email,
            userID: contato.hash
          })
          dataLayer.push({
            event: 'hubspot-view',
            email: this.email,
            userID: contato.hash
          })
        }
      })
    },
    onClickContinue() {
        this.loading = true;
        const salario = this.toFloatNumber(this.faturamentoMensal);

        calculatorCustoCnpjService.calculate(salario, this.atividade).then((result) => {
          this.$emit('onResults', result)
        }).catch((error) => {
          console.log('erro na chamada da api' + error)
        }).finally(()=> {
          this.loading = false;
          this.triggerHubspot()
        })
    },
  },
  mounted() {
    this.VUE_APP_API_FORMS = `https://us-central1-oi-contabilizei${!this.isProd() ? '-test' : ''}.cloudfunctions.net/forms/hubspot/send`;

    this.VUE_APP_API_HUBSPOT = `https://us-central1-oi-contabilizei${!this.isProd() ? '-test' : ''}.cloudfunctions.net/leads/hubspot/`;

    setTimeout(async () => {
      this.locationValue =  removeAccents((await getLocationByAzion()).city)
      this.cidadeAtendida = cidadesAtendidas.some((item) => slug(item.cidade) === slug(this.locationValue));
    }, 2000);
  },
  computed: {
    disableContinue() {
      return !this.isValidStepFinal();
    },
  }
}

</script>
<style lang="scss" src="./CalculatorForm.styles.scss" scoped></style>
